export default "__VITE_ASSET__71651224__"